// TODO S2CX-3856
import type { EventLogField, SyntheticEventLogField } from './event-log-field';

// map legacy synthetic fields to the new ones
export const mapLegacySyntheticFields = new Map([
  ['$country', 'related.country'],
  ['$domain', 'related.domain'],
  ['$eventCode', 'related.event_code'],
  ['$fileName', 'related.file_name'],
  ['$hash', 'related.hash'],
  ['$ipAddress', 'related.ip_address'],
  ['$logSource', 'related.log_source'],
  ['$loginStatus', 'related.login_status'],
  ['$processName', 'related.process_name'],
  ['$user', 'related.user'],
]);

/**
 * @deprecated use fields  module instead
 */
export const filterableFields: Partial<
  Record<EventLogField | SyntheticEventLogField, true>
> = {
  ...Object.fromEntries(
    [...mapLegacySyntheticFields.keys()].map((key) => [key, true]),
  ),
  '@type': true,
  ad__event__auth__logon_type: true,
  ad__event__code: true,
  ad__event__origin__username: true,
  ad__event__title: true,
  auth__type: true,
  client__address: true,
  client__as__number: true,
  client__bytes: true,
  client__domain: true,
  client__geo__city_name: true,
  client__geo__country_iso_code: true,
  client__geo__country_name: true,
  client__ip: true,
  client__ip_classification: true,
  client__packets: true,
  client__port: true,
  client__user__email: true,
  client__user__full_name: true,
  client__user__id: true,
  client__user__name: true,
  client__user__username: true,
  client__whois__registrant__organization: true,
  cloud__client__geo__city_name: true,
  cloud__client__geo__country_name: true,
  cloud__client__user__name: true,
  cloud__event__name: true,
  cloud__resource__name: true,
  cloud__resource__path: true,
  dns__answers__class: true,
  dns__answers__data: true,
  dns__answers__ttl: true,
  dns__answers__type: true,
  dns__question__class: true,
  dns__question__names: true,
  dns__question__type: true,
  dns__question__whois__registrant__organization: true,
  dns__resolved_ip: true,
  dns__response_code: true,
  event__action: true,
  event__category: true,
  event__code: true,
  event__dataset: true,
  event__duration: true,
  event__end: true,
  event__kind: true,
  event__module: true,
  event__outcome: true,
  event__provider: true,
  event__reason: true,
  event__severity: true,
  event__start: true,
  event__type: true,
  event__uuid: true,
  file__directory: true,
  file__hash__md5: true,
  file__hash__sha1: true,
  file__hash__sha256: true,
  file__mime_type: true,
  file__name: true,
  file__path: true,
  firewall__class: true,
  firewall__client: true,
  firewall__connection_id: true,
  firewall__device__name: true,
  firewall__event: true,
  firewall__event_type: true,
  firewall__info: true,
  firewall__message: true,
  firewall__message_id: true,
  firewall__policy: true,
  firewall__rule: true,
  firewall__severity: true,
  firewall__sinkhole: true,
  host__domain: true,
  host__external_ip: true,
  host__geo__city_name: true,
  host__geo__country_iso_code: true,
  host__geo__country_name: true,
  host__hostname: true,
  host__ip: true,
  host__name: true,
  host__os__family: true,
  host__user__email: true,
  host__user__full_name: true,
  host__user__id: true,
  host__user__name: true,
  host__user__username: true,
  http__request__method: true,
  http__request__mime_type: true,
  http__response__content_type: true,
  http__response__status_code: true,
  network__application: true,
  network__bytes: true,
  network__direction: true,
  network__packets: true,
  network__protocol: true,
  network__transport: true,
  observer__geo__city_name: true,
  observer__geo__country_iso_code: true,
  observer__geo__country_name: true,
  observer__type: true,
  organization__deployment__id: true,
  organization__id: true,
  organization__uuid: true,
  process__command_line: true,
  process__executable: true,
  process__hash__md5: true,
  process__hash__sha1: true,
  process__hash__sha256: true,
  process__name: true,
  process__parent__command_line: true,
  process__parent__executable: true,
  process__parent__hash__md5: true,
  process__parent__hash__sha1: true,
  process__parent__hash__sha256: true,
  process__parent__name: true,
  process__parent__pid: true,
  process__parent__ppid: true,
  process__parent__working_directory: true,
  process__pid: true,
  process__ppid: true,
  process__working_directory: true,
  related__as__number: true,
  related__country: true,
  related__domain: true,
  related__email: true,
  related__event_code: true,
  related__file_name: true,
  related__groups: true,
  related__hash: true,
  related__hosts: true,
  related__ip: true,
  related__ip_address: true,
  related__log_source: true,
  related__login_status: true,
  related__process_name: true,
  related__url: true,
  related__user: true,
  related__whois__registrant__name: true,
  related__whois__registrant__organization: true,
  remote__address: true,
  remote__domain: true,
  remote__ip: true,
  remote__port: true,
  remote__registered_domain: true,
  rule__description: true,
  rule__events__category: true,
  rule__events__description: true,
  rule__events__identifier: true,
  rule__events__tags: true,
  server__address: true,
  server__as__number: true,
  server__as__organization__name: true,
  server__bytes: true,
  server__domain: true,
  server__geo__city_name: true,
  server__geo__country_iso_code: true,
  server__geo__country_name: true,
  server__ip: true,
  server__ip_classification: true,
  server__packets: true,
  server__port: true,
  server__user__email: true,
  server__user__full_name: true,
  server__user__id: true,
  server__user__name: true,
  server__user__username: true,
  server__whois__registrant__organization: true,
  service__name: true,
  tags: true,
  threat__severity: true,
  threat__tactic__name: true,
  tls__client__hash__sha256: true,
  tls__server__hash__sha256: true,
  url__domain: true,
  url__full: true,
  url__path: true,
  url__whois__registrant__organization: true,
  user__changes__email: true,
  user__changes__full_name: true,
  user__changes__id: true,
  user__changes__name: true,
  user__changes__username: true,
  user__effective__email: true,
  user__effective__full_name: true,
  user__effective__id: true,
  user__effective__name: true,
  user__effective__username: true,
  user__email: true,
  user__full_name: true,
  user__id: true,
  user__name: true,
  user__target__email: true,
  user__target__full_name: true,
  user__target__id: true,
  user__target__name: true,
  user__target__username: true,
  user__username: true,
  user_agent__description: true,
  user_agent__original: true,
};

/**
 * @deprecated use fields  module instead
 */
export const isFilterableField = (value: string) => {
  return Boolean((filterableFields as Record<string, boolean>)[value]);
};
